// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"211":"works","235":"worksInfo","522":"aboutUs","999":"timeAxis"}[chunkId] + "." + {"211":"78055ad0","235":"a7f4334a","522":"3fb68b1f","999":"4af94a3b"}[chunkId] + ".css";
};